const muiDialogTheme = (theme) => {
  theme.overrides.MuiDialog = {
    paper: {
      borderRadius: 20,
    },
  };
};

export default muiDialogTheme;
